import { connect } from 'react-redux';
import i18next from 'i18next';
import QueryString from 'query-string';
import React from 'react';
import ReactTable from 'react-table';
import { Redirect } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';
import ui from 'redux-ui';

import { AccessHelper, BaseTable } from '../../helpers';
import { AssetTypesService } from '../../services';
import { RowButton } from '../RowButton';
import { ScrollModule } from '../ScrollModule';

@ui({
  key: 'asset-types-list',
  persist: true,
  state: {
    selectedGrouping: null,
    selectedArea: null,
    selectedTag: null,
    prevPage: null
  }
})
@connect(state => ({
  me: state.user.me,
  currentGrouping: state.currentGrouping.currentGrouping
}))
class AssetTypeList extends React.Component {

  constructor(props) {
    super(props);

    const passedState = this.props.currLocation ? this.props.currLocation.state : null;

    this.DEFAULT_SORTED = [{ id: 'name', desc: true }];

    this.refresh = this.refresh.bind(this);    
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);
    this.updateRequestURL = this.updateRequestURL.bind(this);
    this.getForcePage = this.getForcePage.bind(this);
    this.doSearch = this.doSearch.bind(this);

    const parsedOptions = QueryString.parse(this.props.currLocation.search);

    this.state = {
      hasError: false,
      data: [],
      pageCount: null,
      forcePage: null,
      loading: true,
      totalElements: null,
      filtered: [],
      timeout: 0,
      linkTo: passedState ? passedState.linkTo : null,
      localErrorHandler: this.props.localErrorHandler,
      searchValue: passedState && passedState.searchValue ? passedState.searchValue : '',
      currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
      parsedOptions,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/admin/asset-types/view/:assetTypeId'),
      editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/admin/asset-types/edit/:assetTypeId')
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props !== prevProps && this.props.refresh) {
      this.fetchData(this.assetTypesTable && this.assetTypesTable.state ? this.assetTypesTable.state : null);
    }
  }

  getAssetTypes(options, curSearch, callback) {
    AssetTypesService.getAll(options).then((response) => {
      this.props.finishedRefresh();
      if (curSearch === this.state.searchValue) {
        const pageCount = Math.ceil(response.page.totalElements / this.assetTypesTable.state.pageSize);
        const forcePage = this.getForcePage(pageCount);
        callback({
          data: response.assetTypes,
          pageCount,
          forcePage,
          searchValue: curSearch,
          recordsTotal: response.page.totalElements
        });
      }
    }).catch((error) => {
      console.error(error);
      this.props.finishedRefresh();
      this.setState({ hasError: true });
      callback({ data: [], recordsTotal: 0, recordsFiltered: 0 });
      this.state.localErrorHandler(error.message);
    });
  }

  getForcePage(pageCount) {
    let forcePage = null;
    if (this.assetTypesTable && this.assetTypesTable.state && this.assetTypesTable.state.page >= pageCount && pageCount > 0) {
      forcePage = pageCount - 1;
    }
    return forcePage;
  }

  makeDatatableRequest(data, callback) {
    if (this.state.hasError) {
      return;
    }
    const apiOptions = this.state.parsedOptions;
    const options = BaseTable.buildFetchDataOptions(apiOptions, this.DEFAULT_SORTED);
    const curSearch = this.state.searchValue;

    if (this.state.searchValue) {
      options.push({ search: this.state.searchValue });
    }

    this.getAssetTypes(options, curSearch, callback);
  }

  fetchData(tableData) {
    if (this.updateRequestURL(tableData, null)) {
      return;
    }

    this.setState({
      loading: true
    });

    this.makeDatatableRequest(tableData, this.datafetched, null);
  }

  datafetched(res) {
    if (this.state.searchValue && res.search && res.search !== this.state.searchValue) {
      // not current request
      return;
    }

    this.setState({
      data: res.data,
      pageCount: res.pageCount,
      forcePage: res.forcePage,
      loading: false,
      totalElements: res.recordsTotal
    });
  }

  refresh() {
    this.updateRequestURL(this.assetTypesTable && this.assetTypesTable.state ? this.assetTypesTable.state : null);
  }

  updateSearchValue(val) {
    this.setState({ searchValue: val }, () => {
      this.fetchData(this.assetTypesTable && this.assetTypesTable.state ? this.assetTypesTable.state : null);
    });
  }

  doSearch(val) {
    const value = val.target.value;
    this.setState({ searchValue: value });
    if (this.state.timeout) {
      clearTimeout(this.state.timeout);
    }
    this.state.timeout = setTimeout(() => {
      this.updateSearchValue(value);
    }, 500);
  }

  updateRequestURL(tableData, assetLink) {
    const options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED);

    const params = options.map(option => Object.keys(option).map(k => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.currLocation.search ? this.props.currLocation.search : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.pushHistory({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1,
          searchValue: this.state.searchValue,
          linkTo: assetLink
        }
      });
      return true;
    }
    return false;
  }

  render() {
    const {  data, pageCount, loading, totalElements } = this.state;

    if (this.state.linkTo) {
      return (<Redirect
        push
        to={{
          pathname: this.state.linkTo,
          state: {
            backLinkSearch: this.props.currLocation.search,
            searchValue: this.state.searchValue
          }
        }}
      />);
    }

    const dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);

    return (
      <div className="asset-list">
        <ScrollModule />
        <ScrollArea
          speed={0.8}
          className="scroll-container"
          contentClassName="scrollable-content"
          horizontal
        >
          <div className="react-table-custom">
            <ReactTable
              getTheadFilterThProps={(state, rowInfo, column) => ({ style: { overflow: 'visible' } })}
              className="-striped -highlight"
              ref={(el) => { this.assetTypesTable = el; }}
              manual
              data={data}
              pages={pageCount} // Display the total number of pages
              loading={loading} // Display the loading overlay when we need it
              onFetchData={this.fetchData.bind(this)} // Request new data when things change
              totalElements={totalElements}
              showPaginationTop
              style={{ paginationTop: { width: '200px' } }}
              customButtons={[
                { label: i18next.t('pages.assets.add-asset-type'), method: () => { this.setState({ linkTo: `/admin/asset-types/add` }) } }
              ]}
              defaultSorted={this.DEFAULT_SORTED}
              columns={[
                {
                  Header: i18next.t('table-headers.asset-type-name'),
                  id: 'name',
                  accessor: 'name',
                  Cell: cell => <span>{ cell.value }</span>,
                  sortable: false,
                  minResizeWidth: 45,
                  width: 300,
                  filterable: true,
                  Filter: 
                  <div className="filter">
                    <i className="table-search-icon" />
                    <input
                      style={{ width: '100%', margin: '0 auto' }}
                      value={this.state.searchValue}
                      onChange={this.doSearch}
                      type="text"
                      name="search"
                      className="table-search-box"
                      autoComplete="off"
                    />
                  </div>
                },
                {
                  Header: i18next.t('table-headers.asset-type-measures-count'),
                  id: 'availableDeviceDataTypeCount',
                  accessor: 'measures',
                  Cell: cell => <span>{ cell.value ? cell.value.length : 0 }</span>,
                  sortable: false,
                  minResizeWidth: 15,
                  width: 150
                },
                {
                  Header: i18next.t('table-headers.asset-type-default-tags-count'),
                  id: 'defaultTagCount',
                  accessor: 'defaultTags',
                  Cell: cell => <span>{ cell.value ? cell.value.length : 0 }</span>,
                  sortable: false,
                  minResizeWidth: 15,
                  width: 150
                },
                {
                  Header: i18next.t('table-headers.asset-type-metadata-type-count'),
                  id: 'assetMetadataTypeCount',
                  accessor: 'assetTypeMetadataTypes',
                  Cell: cell => <span>{ cell.value ? cell.value.length : 0 }</span>,
                  sortable: false,
                  minResizeWidth: 15,
                  width: 150
                },
                {
                  Header: i18next.t('table-headers.asset-type-assets-count'),
                  id: 'assetCount',
                  accessor: 'assetCount',
                  Cell: cell => <span>{ cell.value ? cell.value : 0 }</span>,
                  sortable: false,
                  minResizeWidth: 15,
                  width: 150
                },                
                {
                  Cell: cell => (<RowButton
                    allowView={this.state.viewAllowed}
                    allowEdit={this.state.editAllowed && cell.original.assetCount == 0}
                    editClick={(rowId) => this.setState({ linkTo: `/admin/asset-types/edit/${rowId}` })}
                    viewClick={(rowId) => this.setState({ linkTo: `/admin/asset-types/view/${rowId}` })}
                    rowId={cell.original.id}
                  />),
                  sortable: false,
                  minResizeWidth: 15
                }
              ]}
              {...dynamicOptions}
            />
          </div>

        </ScrollArea>

      </div>
    );    
  }
}

export default AssetTypeList;
